import { Component, Input, OnInit } from '@angular/core';
import { IErrorDescription } from '@ibank-globals/error';
import { LanguageService } from '@ibank-globals/language';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators/finalize';
import { BaseComponent } from '../../../globals/classes/base.component';
import { SourceApis } from '../../../globals/classes/errorDescription';
import { ErrorHandler } from '../../../globals/classes/errorHandler';
import {
	ICheckUsernameAvailabilityRequest,
	ICreateApplicationRequest,
	ISendCodeRequest,
	IVerifyCodeRequest,
} from '../../classes/existing-onboarding-customer/requests';
import {
	CreateApplicationResponse,
	GetRegisteredMobileNumbersResponse,
	ICheckUsernameAvailabilityResponse,
	ISendCodeResponse,
	SendCodeResponse,
} from '../../classes/existing-onboarding-customer/responses';
import { VerificationApp } from '../../classes/static/enums';
import { ExistingOnboardingInfoService } from '../../services/existing-recovery/info.service';
import { ExistingOnboardingVerificationService } from '../../services/existing-recovery/verification.service';
import { CardDetailsModalComponent } from '../card-details-modal/card-details-modal.component';
import { ConfirmPersonalDetailsModalComponent } from '../confirm-personal-details-modal/confirm-personal-details-modal.component';
import { CreatePasswordIntroModalComponent } from '../create-password-intro-modal/create-password-intro-modal.component';
import { ErrorMessageModalComponent } from '../error-message-modal/error-message-modal.component';
import { ErrorMsgModalComponent } from '../error-msg-modal/error-msg-modal.component';
import { ExistingIbankModalComponent } from '../existing-ibank-modal/existing-ibank-modal.component';
import { AppSettings } from '../../app.settings';
import { interval, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
	selector: 'contact-info-modal',
	template: require('./contact-info-modal.component.html'),
})
export class ContactInfoModalComponent extends BaseComponent implements OnInit {
	@Input() getRegisteredMobileNumbersResponse: GetRegisteredMobileNumbersResponse;
	@Input() appCreateAppResponse: CreateApplicationResponse;
	@Input() appRequest: ICreateApplicationRequest;
	@Input() public isCardModalflow: boolean = false;
	@Input() public isForgetCredentialsRetailModalflow: boolean = false;

	@Input() public isExistingCustomer = false;


	public isNewErrorModal: boolean = AppSettings.isNewErrorModalEnabled;
	public isRebrading = AppSettings.isRebrading;
	public mobileNumber: string;
	public sendCodeRequest: ISendCodeRequest;
	public sendCodeEmailResponse: SendCodeResponse;
	public verifyCodeRequest: IVerifyCodeRequest;
	public checkUsernameAvailabilityRequest: ICheckUsernameAvailabilityRequest;
	public isLoading: boolean = false;
	public isCheckUsernameAvailabilityLoading: boolean = false;
	public isNewCodeLoading: boolean = false;
	public isCodeReceived: boolean = false;

	public hasAcceptTerms: boolean = false;
	public beforeCode: boolean = false;
	public codeSend: boolean = false;
	public emailExistsError: boolean = false;
	public email: string = '';
	public emailResponse: string;
	public countDown: Observable<number>;
	public dynatraceForExistingOnBoarding: boolean = AppSettings.dynatraceForExistingOnBoarding;

	private readonly validEmailRegex = /\S+@\S+\.\S+/;

	public verificationCode: string = '';
	public existingCustomer: boolean = false;
	public langId: string;
	public ibTermsEl: string = './Content/documents/Terms_and_Conditions_existing_IB_gr.pdf';
	public ibTermsEn: string = './Content/documents/Terms_and_Conditions_existing_IB_en.pdf';

	startEnterCodeVal: any;

	public timerActive: boolean = false;
	public timeRemaining: number = 60;
	private timerSubscription: Subscription;

	constructor(
		private activeModal: NgbActiveModal,
		private modalService: NgbModal,
		private _langSvc: LanguageService
	) {
		super();
	}

	public get canContinue(): boolean {
		return (
			this.hasAcceptTerms && this.hasVerificationCode() && this.codeSend && this.hasEmail()
		);
	}

	public get canRecieveCode(): boolean {
		return this.hasEmail();
	}
	public get isCodeExpired(): boolean {
		return this.codeSend && !this.isCodeReceived;
	}

	public ngOnInit(): void {
		this.nullableCheck();
		this.initRequests();
		this._initSubscriptions();
	}

	public toggleSwitch(): void {
		this.hasAcceptTerms = !this.hasAcceptTerms;
	}

	public toggleErrorMessage() {
		this.activeModal.close();
		this.modalService.open(ErrorMsgModalComponent, {
			windowClass: 'modal-small',
		});
	}

	public recieveCode() {
		if (this.dynatraceForExistingOnBoarding)
			this.setDynatraceEvent('ECO_Contact_Details_Receive_Code');
		this.codeSend = true;
		this.invokeSendCode();
	}

	public closeModal(): void {
		this.activeModal.close();
	}

	public toggleBackModal() {
		if (this.isExistingCustomer == true) {
			if (this.isCardModalflow == true || this.isForgetCredentialsRetailModalflow == true)
				this.toggleCardDetailsModal();
			else this.toggleExistiongIbankModal();
		} else {
			this.toggleConfirmPersonalDetailsModal();
		}
	}

	public toggleCreatePasswordIntroModal() {
		if (this.dynatraceForExistingOnBoarding) {
			this.leaveDynatraceEvent(this.startEnterCodeVal);
			this.setDynatraceEvent('ECO_Contact_Details_Continue');
		}
		this.invokeVerifyCode();
	}

	public ibankTermsPdf(): string {
		if (this.langId === 'el') {
			return this.ibTermsEl;
		} else return this.ibTermsEn;
	}
	public resend(): void {
		this.invokeSendCode();
		this.startTimer();
	}

	public findNBGStore(): string {
		if (this.langId === 'el') {
			return 'https://www.nbg.gr/el/Branches-ATMs';
		} else return 'https://www.nbg.gr/en/Branches-ATMs';
	}
	public findBranchEvent() {
		if (this.dynatraceForExistingOnBoarding)
			this.setDynatraceEvent('ECO_Contact_Details_Find_Branch');
	}

	private _setEnterCodeDynatraceEvent() {
		this.startEnterCodeVal = this.enterDynatraceEvent('ECO_Contact_Details_Enter_Code');
	}

	private toggleConfirmPersonalDetailsModal() {
		this.activeModal.close();
		const modalRef = this.modalService.open(ConfirmPersonalDetailsModalComponent, {
			windowClass: 'modal-small',
		});
		(modalRef.componentInstance as ConfirmPersonalDetailsModalComponent).appResponse =
			this.appCreateAppResponse;
		(modalRef.componentInstance as ConfirmPersonalDetailsModalComponent).isCardModalflow =
			this.isCardModalflow;
		(
			modalRef.componentInstance as ConfirmPersonalDetailsModalComponent
		).isForgetCredentialsRetailModalflow = this.isForgetCredentialsRetailModalflow;
	}

	private toggleExistiongIbankModal() {
		this.activeModal.close();
		const modalRef = this.modalService.open(ExistingIbankModalComponent, {
			windowClass: 'modal-small',
		});
		(modalRef.componentInstance as ExistingIbankModalComponent).appRequest = this.appRequest;
		(modalRef.componentInstance as ExistingIbankModalComponent).isExistingCustomer =
			this.isExistingCustomer;
	}
	private toggleCardDetailsModal() {
		this.activeModal.close();
		const modalRef = this.modalService.open(CardDetailsModalComponent, {
			windowClass: 'modal-small',
		});
		(modalRef.componentInstance as CardDetailsModalComponent).isCardModalflow =
			this.isCardModalflow;
		(
			modalRef.componentInstance as CardDetailsModalComponent
		).isForgetCredentialsRetailModalflow = this.isForgetCredentialsRetailModalflow;
	}

	private chooseSendCodeRequestId(): string {
		if (this.isExistingCustomer == true) {
			if (!this.appRequest.appId) return;
			return this.appRequest.appId;
		} else {
			if (!this.appCreateAppResponse.appInfo.appId) return;
			return this.appCreateAppResponse.appInfo.appId;
		}
	}

	private invokeSendCode(): void {
		this.isNewCodeLoading = true;
		const sendcodereq: ISendCodeRequest = {
			appId: this.chooseSendCodeRequestId(),
			verificationTarget: {
				value: this.email,
				type: 'email',
			},
			application: VerificationApp.emailVerification,
		};
		ExistingOnboardingVerificationService.sendCode(sendcodereq)
			.pipe(finalize(() => (this.isNewCodeLoading = false)))
			.subscribe(
				(result) => this.handleSendCodeResponse(result),
				(error) => this.handleError(error, SourceApis.Onboarding)
			);
	}
	private handleSendCodeResponse(response: ISendCodeResponse) {
		if (!!response) {
			if (this.dynatraceForExistingOnBoarding) this._setEnterCodeDynatraceEvent();
			this.sendCodeEmailResponse = new SendCodeResponse(response);
			this.setEmailCodeLifeTime(response);
		}
	}

	private setEmailCodeLifeTime(response: ISendCodeResponse) {
		let expirationMinutes = Math.abs(
			new Date(response.verificationResult.expiresOn).valueOf() -
				new Date(Date.now()).valueOf()
		);
		let buttonLifetime = Math.round(expirationMinutes / 1000);
	}

	private handleError(error: IErrorDescription, sourceApi: SourceApis): void {
		ErrorHandler.newError(error, sourceApi);
	}

	private invokeVerifyCode(): void {
		if (!this.sendCodeEmailResponse.appId) return;
		const req: IVerifyCodeRequest = {
			appId: this.sendCodeEmailResponse.appId,
			verification: {
				verificationCode: this.verificationCode,
				verificationId: this.sendCodeEmailResponse.verificationResult.verificationId,
				verificationTarget: {
					value: this.email,
					type: 'email',
				},
			},
		};
		this.isLoading = true;
		ExistingOnboardingVerificationService.verifyCode(req)
			.pipe(finalize(() => (this.isLoading = false)))
			.subscribe(
				(result) => this.handleVerifyCodeResponse(result),
				(error) => this.handleError(error, SourceApis.Onboarding)
			);
	}

	private handleVerifyCodeResponse(response: boolean) {
		if (!!response && response == true) {
			this.invokeCheckUsernameAvailability();
		} else {
			this.toggleErrorMessage();
		}
	}

	private invokeCheckUsernameAvailability(): void {
		const req: ICheckUsernameAvailabilityRequest = {
			ibUsername: this.email,
			appId: this.sendCodeEmailResponse.appId,
		};

		this.isCheckUsernameAvailabilityLoading = true;
		ExistingOnboardingInfoService.checkUsernameAvailability(req)
			.pipe(finalize(() => (this.isCheckUsernameAvailabilityLoading = false)))
			.subscribe(
				(result) => this.handleCheckUsernameAvailabilityResponse(result),
				(error) => this.handleCheckUsernameAvailabilityError(error, SourceApis.Onboarding)
			);
	}
	private handleCheckUsernameAvailabilityError(
		error: IErrorDescription,
		sourceApi: SourceApis
	): void {
		if (error.code == '7010') {
			this.email = '';
			this.verificationCode = '';
			this.codeSend = false;
			if (this.isNewErrorModal) {
				let modalRef = this.modalService.open(ErrorMsgModalComponent, {
					windowClass: 'modal-xs',
				});
				(modalRef.componentInstance as ErrorMsgModalComponent).icon = 'error-email';
				(modalRef.componentInstance as ErrorMsgModalComponent).title =
					'Το email χρησιμοποιείται ήδη';
				(modalRef.componentInstance as ErrorMsgModalComponent).action = 'Ενημερώθηκα';
				(modalRef.componentInstance as ErrorMsgModalComponent).message = 'Το email ';
				(modalRef.componentInstance as ErrorMsgModalComponent).input = this.emailResponse;
				(modalRef.componentInstance as ErrorMsgModalComponent).message2 =
					' είναι ήδη καταχωρημένο ως username. Παρακαλούμε χρησιμοποιήστε ένα διαφορετικό email το οποίο θα οριστεί ως το username σας.';
			} else {
				const modalRef = this.modalService.open(ErrorMessageModalComponent, {
					windowClass: 'modal-small',
				});
				(modalRef.componentInstance as ErrorMessageModalComponent).wrongEmail = true;
				(modalRef.componentInstance as ErrorMessageModalComponent).email =
					this.emailResponse;
			}
		} else ErrorHandler.newError(error, sourceApi);
	}
	private handleCheckUsernameAvailabilityResponse(response: ICheckUsernameAvailabilityResponse) {
		if (!!response && response.usernameAvailability == true) {
			this.emailResponse = response.ibUsername;
			this.activeModal.close();
			const modalRef = this.modalService.open(CreatePasswordIntroModalComponent, {
				windowClass: 'modal-small',
			});
			(modalRef.componentInstance as CreatePasswordIntroModalComponent).ibUsernameRequest =
				this.email;
			(
				modalRef.componentInstance as CreatePasswordIntroModalComponent
			).ibUsernameCheckUsernameAvailabilityResp = response.ibUsername;
			(modalRef.componentInstance as CreatePasswordIntroModalComponent).appCreateAppResponse =
				this.appCreateAppResponse;
			(
				modalRef.componentInstance as CreatePasswordIntroModalComponent
			).getRegisteredMobileNumbersResponse = this.getRegisteredMobileNumbersResponse;
			(modalRef.componentInstance as CreatePasswordIntroModalComponent).isExistingCustomer =
				this.isExistingCustomer;
			(modalRef.componentInstance as CreatePasswordIntroModalComponent).createAppRequest =
				this.appRequest;
			(modalRef.componentInstance as CreatePasswordIntroModalComponent).isCardModalflow =
				this.isCardModalflow;
			(
				modalRef.componentInstance as CreatePasswordIntroModalComponent
			).isForgetCredentialsRetailModalflow = this.isForgetCredentialsRetailModalflow;
		} else {
			this.toggleErrorMessage();
		}
	}

	private nullableCheck(): void {
		if (
			!!this.getRegisteredMobileNumbersResponse &&
			!!this.getRegisteredMobileNumbersResponse.mobileNumber
		) {
			this.mobileNumber = this.getRegisteredMobileNumbersResponse.mobileNumber;
		} else {
			this.mobileNumber = '-';
		}
	}

	private initRequests() {
		this.sendCodeRequest = {
			appId: '',
			application: VerificationApp.emailVerification,
			verificationTarget: {
				value: this.email,
				type: 'email',
			},
		};
		this.verifyCodeRequest = {
			appId: this.sendCodeRequest.appId,
			verification: {
				verificationCode: this.verificationCode,
				verificationId: this.sendCodeRequest.appId,
				verificationTarget: {
					value: this.email,
					type: 'email',
				},
			},
		};
		this.checkUsernameAvailabilityRequest = {
			ibUsername: this.email,
		};
	}

	private _initSubscriptions(): void {
		this.mortalize(this._langSvc.activeLanguage$).subscribe((lang) => (this.langId = lang));
	}
	private hasVerificationCode(): boolean {
		if (this.verificationCode && this.verificationCode.trim().length >= 4) return true;
		else return false;
	}

	private hasEmail(): boolean {
		if (this.email && this.isValidEmail(this.email)) {
			this.emailResponse = this.email;
			return true;
		} else return false;
	}
	private isValidEmail(email: string): boolean {
		var isValid = this.validEmailRegex.test(email);
		return isValid;
	}

	public startTimer() {
		this.timerActive = true;
		this.timeRemaining = 60;

		this.timerSubscription = interval(1000)
			.pipe(take(61))
			.subscribe(() => {
				if (this.timeRemaining > 0) {
					this.timeRemaining--;
				} else {
					this.timerActive = false;
					if (this.timerSubscription) {
						this.timerSubscription.unsubscribe();
					}
				}
			});
	}

	// Format remaining time as MM:SS
	public formatTime(): string {
		const minutes: number = Math.floor(this.timeRemaining / 60);
		const seconds: number = this.timeRemaining % 60;

		return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
	}
}
